export const ordinal = (value: number): string => {
  return value === 1
    ? "1st"
    : value === 2
    ? "2nd"
    : value === 3
    ? "3rd"
    : `${value}th`;
};
